import Application from "../../Application";
import PositionTypesPresenter, {
  IPositionTypesPresenter
} from "../../presenter/position/PositionTypesPresenter";
import GetPositionTypesInteractor from "./GetPositionTypesInteractor";

export default class ShowPositionTypesInteractor {
  private application: Application;
  private output?: IPositionTypesPresenter;

  constructor(application) {
    this.application = application;
  }

  async getPositionTypes() {
    return await this.application.container
      .resolve<GetPositionTypesInteractor>("getPositionTypes")
      .execute();
  }

  execute() {
    this.output = PositionTypesPresenter({
      application: this.application,
      initialState: {
        positionTypes: []
      }
    });

    this.getPositionTypes().then(
      positionTypes =>
        this.output && this.output.setPositionTypes(positionTypes)
    );

    return this.output;
  }
}
